import type { NavItems } from '@ksyos/design-system';
import { SideNav } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IServicesByServiceGroupForEpisodeCategory } from '@common/interfaces/servicesByServiceGroupForEpisodeCategory';
import { ManagerAuthorization } from '@common/enums';
import { SideNavItem } from '@frontend/components/elements/navigation/components/SideNavItem';
import { fetchJson } from '@frontend/store/fetch';
import { translateKey } from '@frontend/translate';
import { getCarePathMenuItems, hasOneAuthorization, useUiStateContext } from '@frontend/utils';

export interface IGroupNavigationProps {
    groupId: string;
}

export function GroupNavigation(props: IGroupNavigationProps): JSX.Element {
    const [navigationItems, setNavigationItems] = useState<NavItems[]>([]);
    const { groupId } = props;
    const [serviceGroupsByEpisodeCategory, setServiceGroupsByEpisodeCategory] = useState<
        IServicesByServiceGroupForEpisodeCategory[] | undefined
    >();
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    useEffect(() => {
        getServiceGroupsByEpisodeCategory();
    }, []);

    useEffect(() => {
        if (serviceGroupsByEpisodeCategory) {
            getMenuItems();
        }
    }, [groupId, serviceGroupsByEpisodeCategory]);

    if (!groupId || navigationItems.length === 0) {
        return <></>;
    }

    return (
        <SideNav>
            {navigationItems.map((item) => (
                <SideNavItem
                    defaultOpenKey="group"
                    item={item}
                    key={item.key}
                    onClose={handleClose}
                />
            ))}
        </SideNav>
    );

    async function getServiceGroupsByEpisodeCategory() {
        const result = await fetchJson(
            `/api/serviceGroupMemberships?groupId=${groupId}&groupByEpisodeCategory=true`,
            'GET'
        );
        setServiceGroupsByEpisodeCategory(result.json.items);
    }

    async function getMenuItems() {
        const subItems: NavItems[] = [];
        const items: NavItems[] = [
            {
                items: subItems,
                key: 'group',
                label: translateKey('groups.group'),
                to: `/groups/${groupId}/view`,
                variant: 'link',
            },
        ];
        if (hasOneAuthorization(ManagerAuthorization.groupAddEdit)) {
            subItems.push(
                ...(await getCarePathMenuItems({
                    groupId: groupId,
                    pathname: `/groups/${groupId}/view`,
                }))
            );
        }

        setNavigationItems(items);
    }

    function handleClose() {
        if (uiState.isTopBarOpen) {
            dispatchUiStateAction({ isTopBarOpen: false, type: 'setIsTopBarOpen' });
        }
    }
}
